import { cookie } from "../lib/cookies";
import { getCloudflareData as getCFData } from "../lib/cf-helpers";
import { getSiteLanguage } from "../lib/lang";

export const getLanguage = () => getSiteLanguage();

export const getCloudflareData = () => {
  return getCFData();
};

export const getSegmentData = () => {
  return window.analytics?.user?.().traits();
};

export const getIsPDUser = () => {
  const userId = cookie("ajs_user_id");
  return userId && userId !== "";
};
